import { z } from 'zod';

export const forgotPasswordSchema = z.object({
  email: z
    .string()
    .min(1, { message: 'Debe ingresar un email' })
    .email({ message: 'Debe ingresar un email válido' }),
});

export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;
